var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Alert } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
export const SonarAlert = (_a) => {
    var { active, afterClose } = _a, otherProps = __rest(_a, ["active", "afterClose"]);
    const containerRef = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        var _a;
        if (!active) {
            const closeButton = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.ant-alert-close-icon');
            closeButton === null || closeButton === void 0 ? void 0 : closeButton.click();
        }
        else if (active) {
            setVisible(true);
        }
    }, [active, containerRef]);
    const handleAfterClose = useCallback(() => {
        setVisible(false);
        if (afterClose) {
            afterClose();
        }
    }, [afterClose]);
    if (!visible) {
        return null;
    }
    return (React.createElement("div", { ref: containerRef },
        React.createElement(Alert, Object.assign({ afterClose: handleAfterClose }, otherProps))));
};
